import React from "react";
import Footer from "./footer";
import SectionTitle from "./section-title";
import Leaders from "./leaders";
import Promise from "./promise";
import Uniform from "./uniform";

function Beavers() {
  return (
    <div className="beavers" id="beavers">
      <SectionTitle section={"beavers"} />
      <Leaders section={"beavers"} />
      <Promise
        section={"beavers"}
      />
      <Uniform 
        section={"beavers"}
      />
      <Footer />
    </div>
  );
}

export default Beavers;
